import { ToggleEvent } from "slotworks/graphics/elements/flexi-toggle";
import Layers from "slotworks/graphics/layers/layers";
import AbstractToggleControl from "slotworks/smart-ui/controls/abstract/abstract-toggle-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class StopOnWinToggleControl extends AbstractToggleControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.toggle.on(ToggleEvent.CHANGE, this.onChangeHandler);
    }

    public updateOptions(options: ControlOptions) {
        this.toggle.setValue(!options.stopOnAnyWin);
    }

    protected onChangeHandler = (value: boolean) => {
        const options = new ControlOptions();
        options.stopOnAnyWin = value;

        this.onChange.dispatch(options);
    }
}
